module.exports = __webpack_public_path__ + "docs/idn-primer-1.0.pdf";